import React from 'react'
import { CartItems } from '../Components/Cartitems/CartItems'

export const Cart = () => {
  return (
    <div><CartItems/></div>
  )
}
